module.exports = __webpack_public_path__ + "static/img/sphqrcode.fea9016.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sphqrcode.png
// module id = Msi4
// module chunks = 89